import Vue from "vue";
import axios from "axios";
import countriesByContinent from "./countries.json";
import alumnimapwrapper from "./map.vue";
import alumnimap from "./alumni-map.vue";
import alumnilist from "./alumni-list.vue";
import modal from "./modal.vue";
import VueRouter from 'vue-router'

const VueScrollTo = require("vue-scrollto");

Vue.use(VueRouter)

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: null,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

const routes = [
  { path: '/WAT50N/map',
    components: {
      default: alumnimap
    }
  },
  {
    path: '/WAT50N/map/list',
    components: {
      default: alumnilist
    },
    children: [
      {
        path: '/WAT50N/map/list/:id',
        component: modal
      }
    ]
  }

]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export const vueApp = new Vue({
  router,
  el: "#mapApp",
  delimiters: ["${", "}"],
  data() {
    return {
      alumni: [],
      offset: null,
      pageSize: 100000,

      filter: {
        Program_Affiliation__c: "",
        "Master_Year__r.Year__c": ""
      },
      countriesByContinent: null,
      loading: true
    };
  },

  async created() {
    this.getAlumni();
  },

  mounted() {
    // console.log(this.$route)
  },
  updated() {
    // console.log(this.filter)
  },

  computed: {
    continents() {
      const continentsArray = [
        "Europe",
        "Asia",
        "North America",
        "Africa",
        "Antarctica",
        "South America",
        "Oceania"
      ];
      let alumni = [];
      let continents = {};

      if (this.countriesByContinent) {
        Object.values(this.countriesByContinent).forEach((continent, index) => {
          let countries = {};
          continent.forEach(country => {
            const countryName = country.name;
            const countryLocation = country.location;
            const countryEmoji = country.emoji;
            let tjAlumni = null;
            let jkAlumni = null;

            tjAlumni = this.alumni.filter(student => {
              if (
                student.Applications__r &&
                student.Applications__r.records[0]
                  .Proposed_Project_Countries__c &&
                student.Applications__r.records[0].Proposed_Project_Countries__c.includes(
                  countryName
                )
              ) {
                return true;
              } else {
                return false;
              }
            });

            jkAlumni = this.alumni.filter(student => {
              let flag = false;

              if (student.Fellow_Years__r && student.Fellow_Years__r.records) {
                student.Fellow_Years__r.records.forEach(record => {
                  if (
                    record.Internship__r &&
                    record.Internship__r.International_Country__c &&
                    record.Internship__r.International_Country__c == countryName
                  ) {
                    flag = true;
                  }
                });
              }
              if (flag) {
                return true;
              } else {
                return false;
              }
            });

            countries[countryName] = {
              name: null,
              continent: null,
              location: null,
              tj: null,
              jk: null,
              id: null,
              emoji: null
            };
            countries[countryName]["name"] = countryName;
            countries[countryName]["continent"] = continentsArray[index];
            countries[countryName]["location"] = countryLocation;
            countries[countryName]["tj"] = tjAlumni;
            countries[countryName]["jk"] = jkAlumni;
            countries[countryName]["id"] = this.stringToCamelcase(countryName);
            countries[countryName]["emoji"] = countryEmoji;
          });
          continents[continentsArray[index]] = countries;
        });

        return continents;
      }
    }
  },

  methods: {
    async getAlumni() {
      this.loading = true;
      const response = await axios.get("/actions/community/data/get-alumni", {
        params: {
          offset: this.offset,
          limit: this.pageSize,
          filter: this.filter
        }
      });
      console.log(response);
      // console.log(response.data.records)
      this.alumni = response.data.records;
      this.countriesByContinent = countriesByContinent;
      this.loading = false;
    },

    updateYear(year) {
      this.filter["Master_Year__r.Year__c"] = year;
      this.getAlumni();
    },
    stringToCamelcase(str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
        return index == 0 ? match.toLowerCase() : match.toUpperCase();
      });
    }
  },
  components: {
    alumnimapwrapper, alumnimap, alumnilist, modal
  }
});



// WEBPACK FOOTER //
// ./scripts/map-app.js